import axios from "@axios";
import * as ep from "./endpoints";

export default class Service {
  static fetchNgoData() {
    return axios.get(ep.NGO_BY_ID).then((res) => res.data);
  }
  static fetchMainNgoData() {
    return axios.get(ep.MAIN_NGO).then((res) => res.data);
  }
  static fetchDocs(slug) {
    return axios.get(ep.DOCS(slug)).then((res) => res.data);
  }
  static fetchDrivers(id) {
    return axios.get(ep.GET_BANK_ACCOUNTS_DRIVERS(id)).then((res) => res.data);
  }
  static fetchContactInfo() {
    return axios.get(ep.CONTACT_INFO).then((res) => res.data);
  }
  static fetchServicesAndClassifications() {
    return axios.get(ep.SERVICES_AND_CLASSIFICATIONS).then((res) => res.data);
  }
  static fetchServicesAndClassification() {
    return axios.get(ep.CLASSIFICATIONS).then((res) => res.data);
  }
  static updateContactInfo(payload) {
    return axios
      .put(ep.CONTACT_INFO_BY_ID(payload.id), payload.form)
      .then((res) => res);
  }
  static updateNgoInfo(payload) {
    return axios.post(ep.NGO_BY_ID, payload).then((res) => res);
  }
  static updateDriver(payload) {
    return axios
      .put(ep.BANK_ACCOUNTS_DRIVERS_BY_id(payload.id), payload.form)
      .then((res) => res);
  }
  static updateBankAccount(payload) {
    return axios
      .put(ep.BANK_ACCOUNT_BY_ID(payload.id), payload.form)
      .then((res) => res);
  }
  static deleteBankAccount(id) {
    return axios.delete(ep.BANK_ACCOUNT_BY_ID(id)).then((res) => res);
  }
  static addBankAccount(payload) {
    return axios.post(ep.BANK_ACCOUNTS, payload).then((res) => res);
  }
  static addDriver(payload) {
    return axios
      .post(ep.CREATE_BANK_ACCOUNTS_DRIVERS, payload)
      .then((res) => res);
  }
  static saveContactInfo(data) {
    return axios.post(ep.CONTACT_INFO, data).then((res) => res);
  }
  static deleteContactInfo(payload) {
    return axios
      .post(ep.CONTACT_INFO_BY_ID(payload.id), {
        branch_id: payload.branch_id,
      })
      .then((res) => res);
  }
  static fetchBranches() {
    return axios.get(ep.BRANCHES).then((res) => res.data);
  }
  static updateBranch(payload) {
    var form = new FormData();
    for (const key in payload) {
      if (Object.hasOwnProperty.call(payload, key)) {
        const element = payload[key];
        if (element !== null) form.append(key, element);
      }
    }
    form.append("_method", "PUT");
    return axios.post(ep.BRANCH_BY_ID(payload.id), form).then((res) => res);
  }
  static addBranch(payload) {
    var form = new FormData();
    for (const key in payload) {
      if (Object.hasOwnProperty.call(payload, key)) {
        const element = payload[key];
        if (element !== null) form.append(key, element);
      }
    }
    return axios.post(ep.BRANCHES, form).then((res) => res);
  }
  static deleteBranch(id) {
    return axios.delete(ep.BRANCH_BY_ID(id)).then((res) => res);
  }

  static fetchServiceCentres() {
    return axios.get(ep.SERVICE_CENTRES).then((res) => res.data);
  }

  static saveServiceCentre(payload) {
    return axios.post(ep.SERVICE_CENTRES, payload).then((res) => res.data);
  }

  static updateServiceCentre(payload) {
    return axios
      .put(ep.SERVICE_CENTRES_BY_ID(payload.id), payload)
      .then((res) => res.data);
  }

  static updateNgoLogo(logo) {
    var req = new FormData();
    req.append("logo", logo);
    req.append("_method", "PUT");

    return axios.post(ep.LOGO, req).then((res) => res);
  }

  static deleteServiceCentre(id) {
    return axios.delete(ep.SERVICE_CENTRES_BY_ID(id)).then((res) => res.data);
  }
  static deleteDriver(id) {
    return axios
      .delete(ep.BANK_ACCOUNTS_DRIVERS_BY_id(id))
      .then((res) => res.data);
  }

  static getLogs() {
    return axios.get(ep.LOGS).then((res) => res.data);
  }

  // Notifications

  static fetchNotifications() {
    return axios.get(ep.NOTIFICATIONS).then((res) => res.data);
  }
  // static addNotification(payload) {
  //   return axios.post(ep.NOTIFICATIONS, payload).then((res) => res.data);
  // }
  // static updateNotification(payload) {
  //   return axios
  //     .put(ep.NOTIFICATION_BY_ID(payload.id), payload)
  //     .then((res) => res.data);
  // }
  // static deleteNotification(id) {
  //   return axios.delete(ep.NOTIFICATION_BY_ID(id)).then((res) => res.data);
  // }
  // static sendNotification(payload) {
  //   return axios.post(ep.SEND_NOTIFICATION, payload).then((res) => res.data);
  // }
  static deleteDoc(id) {
    return axios.delete(ep.DOC_BY_KEY(id)).then((res) => res.data);
  }
  static updateHqInfo(form) {
    return axios.post(ep.MAIN_HQ, form);
  }
  static confirmInfo(status) {
    return axios
      .post(
        ep.CONFIRM_INFO,
        {},
        {
          params: {
            status,
          },
        }
      )
      .then((res) => res);
  }
  static updateProfileScore() {
    return axios.post(ep.PROFILE_SCORE);
  }
  static refreshProfileScore() {
    return axios.get(ep.PROFILE_SCORE);
  }
}
